import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { pulseRate7day, pulseRate30day } from '../mockData/pulse-rate-data';

const PulseRateApi = [
  rest.get(`${API_ROOT}pulse-rate`, (req, res, ctx) => {
    const period = req.url.searchParams.get('period');
    if (period === '7') {
      return res(ctx.json(pulseRate7day));
    }
    return res(ctx.json(pulseRate30day));
  }),
];

export default PulseRateApi;
